import { d as debounce } from '../../unsorted/index5.js';
import { useBrowserLayoutEffect } from '../../hooks/useBrowserLayoutEffect.js';
import { useEventListener } from '../../hooks/useEventListener.js';
import { u as useWindowSizeStore } from '../windowSizeContext/windowSizeContext.js';

var DEFAULT_RESIZE_DEBOUNCE_TIME = 40;

function SetWindowSize(_ref) {
  var _ref$resizeDebounceDu = _ref.resizeDebounceDuration,
    resizeDebounceDuration = _ref$resizeDebounceDu === void 0 ? DEFAULT_RESIZE_DEBOUNCE_TIME : _ref$resizeDebounceDu;
  var _useWindowSizeStore = useWindowSizeStore(function (state) {
      return state;
    }),
    setState = _useWindowSizeStore.setState;
  var debouncedOnResize = debounce(function () {
    setState({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }, resizeDebounceDuration);
  useEventListener("resize", debouncedOnResize, {
    current: typeof window !== "undefined" ? window : null
  });
  useBrowserLayoutEffect(function () {
    return setState({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }, []);
  return null;
}

export { DEFAULT_RESIZE_DEBOUNCE_TIME as D, SetWindowSize as S };
//# sourceMappingURL=SetWindowSize.js.map
